var map = {
	"./2750819.png": 280,
	"./PentaErpLogo1.png": 387,
	"./PentaErpLogo2.png": 193,
	"./a-profile-default.png": 382,
	"./accounting.svg": 670,
	"./add-file.svg": 388,
	"./anulate-file.svg": 389,
	"./arrow-back.svg": 384,
	"./arrow-down-sign-to-navigate.svg": 254,
	"./basket.svg": 671,
	"./bell.svg": 380,
	"./building.svg": 672,
	"./business-building-1238699.jpg": 673,
	"./calendar.svg": 674,
	"./camera.svg": 390,
	"./cart.svg": 675,
	"./cash-banks-movements.svg": 676,
	"./category.svg": 677,
	"./check.svg": 678,
	"./color-warehouse.svg": 679,
	"./copy-file.svg": 391,
	"./customer.svg": 680,
	"./delete-file.svg": 392,
	"./diagram.svg": 393,
	"./diet.svg": 681,
	"./dollar.svg": 682,
	"./download.svg": 394,
	"./edit-file.svg": 395,
	"./electronic-book.svg": 683,
	"./email.svg": 396,
	"./family.svg": 684,
	"./financiero.svg": 685,
	"./formula.svg": 686,
	"./home.svg": 687,
	"./id-card.svg": 688,
	"./information.svg": 381,
	"./invoice.svg": 689,
	"./light.svg": 397,
	"./loginBackground.jpg": 690,
	"./logs.svg": 691,
	"./master-account.svg": 692,
	"./menu-de-puntos.svg": 693,
	"./open-book.svg": 694,
	"./piggy-bank.svg": 695,
	"./printer.svg": 398,
	"./profile-default.jpg": 696,
	"./question-mark.svg": 385,
	"./report-paper.svg": 697,
	"./report.svg": 698,
	"./retirement.svg": 699,
	"./safe-box.svg": 700,
	"./salary.svg": 701,
	"./sales-tag.svg": 702,
	"./sales.svg": 703,
	"./search.svg": 378,
	"./setting-gears.svg": 704,
	"./shield.svg": 705,
	"./shopping-basket.svg": 706,
	"./shopping-cart.svg": 707,
	"./spain.svg": 379,
	"./supplier.svg": 708,
	"./table.svg": 709,
	"./team.svg": 710,
	"./upload.svg": 399,
	"./users.svg": 711,
	"./view.svg": 400,
	"./warehouse.svg": 712,
	"./weight.svg": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;